/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceEntryRequest } from './BalanceEntryRequest';
import {
    BalanceEntryRequestFromJSON,
    BalanceEntryRequestFromJSONTyped,
    BalanceEntryRequestToJSON,
    BalanceEntryRequestToJSONTyped,
} from './BalanceEntryRequest';
import type { ClaimCollateralRequest } from './ClaimCollateralRequest';
import {
    ClaimCollateralRequestFromJSON,
    ClaimCollateralRequestFromJSONTyped,
    ClaimCollateralRequestToJSON,
    ClaimCollateralRequestToJSONTyped,
} from './ClaimCollateralRequest';

/**
 * 
 * @export
 * @interface CreateClaimRequest
 */
export interface CreateClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    creditorId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    representativeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    legalBasis: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    disputedStatus: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    collateralStatus: string;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimRequest
     */
    expectedLossPercent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    claimEntirelyDisputed?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimRequest
     */
    recognizedAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    srvRegistrationStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateClaimRequest
     */
    srvOrderNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClaimRequest
     */
    notes?: string | null;
    /**
     * 
     * @type {Array<ClaimCollateralRequest>}
     * @memberof CreateClaimRequest
     */
    collaterals?: Array<ClaimCollateralRequest>;
    /**
     * 
     * @type {Array<BalanceEntryRequest>}
     * @memberof CreateClaimRequest
     */
    balanceEntries?: Array<BalanceEntryRequest>;
}

/**
 * Check if a given object implements the CreateClaimRequest interface.
 */
export function instanceOfCreateClaimRequest(value: object): value is CreateClaimRequest {
    if (!('creditorId' in value) || value['creditorId'] === undefined) return false;
    if (!('legalBasis' in value) || value['legalBasis'] === undefined) return false;
    if (!('disputedStatus' in value) || value['disputedStatus'] === undefined) return false;
    if (!('collateralStatus' in value) || value['collateralStatus'] === undefined) return false;
    return true;
}

export function CreateClaimRequestFromJSON(json: any): CreateClaimRequest {
    return CreateClaimRequestFromJSONTyped(json, false);
}

export function CreateClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'creditorId': json['creditorId'],
        'representativeId': json['representativeId'] == null ? undefined : json['representativeId'],
        'caseNumber': json['caseNumber'] == null ? undefined : json['caseNumber'],
        'legalBasis': json['legalBasis'],
        'disputedStatus': json['disputedStatus'],
        'collateralStatus': json['collateralStatus'],
        'expectedLossPercent': json['expectedLossPercent'] == null ? undefined : json['expectedLossPercent'],
        'claimEntirelyDisputed': json['claimEntirelyDisputed'] == null ? undefined : json['claimEntirelyDisputed'],
        'recognizedAmount': json['recognizedAmount'] == null ? undefined : json['recognizedAmount'],
        'srvRegistrationStatus': json['srvRegistrationStatus'] == null ? undefined : json['srvRegistrationStatus'],
        'srvOrderNumber': json['srvOrderNumber'] == null ? undefined : json['srvOrderNumber'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'collaterals': json['collaterals'] == null ? undefined : ((json['collaterals'] as Array<any>).map(ClaimCollateralRequestFromJSON)),
        'balanceEntries': json['balanceEntries'] == null ? undefined : ((json['balanceEntries'] as Array<any>).map(BalanceEntryRequestFromJSON)),
    };
}

export function CreateClaimRequestToJSON(json: any): CreateClaimRequest {
    return CreateClaimRequestToJSONTyped(json, false);
}

export function CreateClaimRequestToJSONTyped(value?: CreateClaimRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creditorId': value['creditorId'],
        'representativeId': value['representativeId'],
        'caseNumber': value['caseNumber'],
        'legalBasis': value['legalBasis'],
        'disputedStatus': value['disputedStatus'],
        'collateralStatus': value['collateralStatus'],
        'expectedLossPercent': value['expectedLossPercent'],
        'claimEntirelyDisputed': value['claimEntirelyDisputed'],
        'recognizedAmount': value['recognizedAmount'],
        'srvRegistrationStatus': value['srvRegistrationStatus'],
        'srvOrderNumber': value['srvOrderNumber'],
        'notes': value['notes'],
        'collaterals': value['collaterals'] == null ? undefined : ((value['collaterals'] as Array<any>).map(ClaimCollateralRequestToJSON)),
        'balanceEntries': value['balanceEntries'] == null ? undefined : ((value['balanceEntries'] as Array<any>).map(BalanceEntryRequestToJSON)),
    };
}

